import ColorDropDown from './ColorDropDown';
import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { useDispatch } from 'react-redux';
import { getUserData } from '../../../../../_redux';

function LabelModal({ show, handleClose }) {
	const dispatch = useDispatch();
	const [color, setColor] = useState('');
	const [title, setTitle] = useState('');
	const handleCreateVisit = async () => {
		try {
			const response = await fetchWrapper.post(`/label`, {
				key: title,
				color: color,
				category: 'visits',
			});
			console.log(response);
			handleClose();
			dispatch(getUserData());
		} catch (err) {
			console.log(err);
		}
	};
	return (
		<Modal show={show} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>Create Labels</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="d-flex justify-content-between">
					<ColorDropDown setColor={setColor} color={color} />
					<input className="px-2 w-100" value={title} onChange={(e) => setTitle(e.target.value)} />
					<Button className="ml-2" onClick={handleCreateVisit}>
						Create
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
}

export default LabelModal;
